import './Main.css';
import './CSS/PaE.css';
import {PaEInfo} from './ProjectInfo.jsx';
import {FooterLinks, HeaderLinks} from "./ToolBox.jsx"
import { Link } from 'react-router-dom';

const Explaination = () => {
  return(
    <div id="summaryBox">
      <p id="summary">We are a church that finds joy in reaching out to our community and participating in over 30 ministries. These are a few of the missions, projects, and activities we are proud to be a part of.</p>
    </div>  
  )
}

const EventTemplate = () => {
  return(
    <div>
      {PaEInfo.map((activity) =>(
        <div key={activity.id} className="section">
          <img id="eventPhoto" src={activity.img} alt={activity.alt} />
          <div className="innerSec">
            <span id='title'>{activity.title}</span>

            {activity.content.map((line, i) => (
              <p key={i} id='info'>{line.Info}</p>
            ))}
          </div>
          <img id="eventPhoto" src={activity.img2} alt={activity.alt2} />
          <div className="innerSec">
            <span id='title'>{activity.title2}</span>

            {activity.content2.map((line, i) => (
              <p key={i} id='info'>{line.Info}</p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function PaEPage() {
  return(
    <div className="backgroundGradient">
      <Link to="/"><img src="/Images/Chapel Logo.png" alt="Pennington Chapel" /></Link>
      <HeaderLinks />
      <div className="banner">
        <h2 className="bannerText">Outreach</h2>
      </div>
      <Explaination />
      <EventTemplate />
      <FooterLinks />
    </div>
  )
}